import React from 'react';
import { bindActionCreators } from 'redux';
import { SubmissionError } from 'redux-form';
import { withRouter } from 'react-router';
import { parse } from 'qs';
import { connect } from 'react-redux';
import { getAxios } from 'utils/api/axiosClient';
import {
  signUp,
  checkInviteId,
  clearInviteData,
} from 'store/actions/auth.actions';
import { getReduxFormError } from 'utils/forms/getReduxFormError';
import { ROUTES } from 'config/constants';
import { SignUpForm } from './SignUpForm';

@withRouter
@connect(
  ({ authState }) => ({
    authState,
  }),
  (dispatch) => ({
    signUp: bindActionCreators(signUp, dispatch),
    checkInviteId: bindActionCreators(checkInviteId, dispatch),
    clearInviteData: bindActionCreators(clearInviteData, dispatch),
    dispatch,
  }),
)
export default class SignUpPage extends React.PureComponent {
  componentDidMount() {
    const {
      location: { search } = {},
      authState: { authInfo: { inviteData = {} } = {} },
      clearInviteData,
    } = this.props;
    const { token } = parse(search, { ignoreQueryPrefix: true });

    if (inviteData.hasOwnProperty('email')) {
      clearInviteData();
    }
    if (token) {
      this.checkInvite(token);
    }
  }

  checkInvite = async (token) => {
    const { code } = await this.props.checkInviteId(token);

    if (code !== 'success') {
      const { history = {} } = this.props;

      history.replace(ROUTES.NOT_AVAILABLE);
      return;
    }
  };

  handleSubmit = async (values) => {
    const { location: { search } = {}, history = {} } = this.props;
    const { token } = parse(search, { ignoreQueryPrefix: true });
    const axios = getAxios();
    // noinspection JSUnusedLocalSymbols
    const { repeatPassword, acceptTermsAndConditions, ...payload } = values;

    if (token) {
      const inviteFromResponse = await axios.put(
        `${ROUTES.SIGN_UP_INVITE_FROM(token)}`,
      );

      if (!inviteFromResponse || inviteFromResponse.code !== 'success') {
        history.replace(ROUTES.NOT_AVAILABLE);
        throw new SubmissionError(getReduxFormError(inviteFromResponse));
      }
    }

    const response = await this.props.signUp(payload);

    if (response && response.code === 'success') {
      const { history = {} } = this.props;
      history.replace(ROUTES.CONGRATULATION_SIGN_UP);
      return;
    }
    throw new SubmissionError(getReduxFormError(response));
  };

  render() {
    const { authState = {} } = this.props;
    const { isAuthProcessed } = authState;

    return (
      <SignUpForm
        isFormProcessed={isAuthProcessed}
        onSubmit={this.handleSubmit}
      />
    );
  }
}
